var map = {
	"./anima-logo-text-black.svg": "614e",
	"./anima-logo-text.svg": "a2ac",
	"./anima-logo.svg": "a1ac",
	"./announcement-alert.svg": "abb5",
	"./announcement.svg": "5e5c",
	"./arrow-left.svg": "5bc9",
	"./arrow-right.svg": "dfd8",
	"./arrows-dropdown.svg": "a002",
	"./assets.svg": "392c",
	"./bell.svg": "24d1",
	"./black-lock.svg": "d0f2",
	"./caret-left.svg": "f749",
	"./caret-right.svg": "5d8e",
	"./carret-down.svg": "24b2",
	"./carret-right.svg": "87d1",
	"./carret-top.svg": "8c8d",
	"./check.svg": "8a2e",
	"./checked.svg": "e3fab",
	"./chevron-down.svg": "ef3aa",
	"./circle-check-inverse.svg": "422b",
	"./circle-check.svg": "9f88",
	"./circle-minus-red.svg": "6f7a",
	"./circle-minus.svg": "97e1",
	"./circle-play.svg": "ab5a",
	"./circle-plus-dark.svg": "740c",
	"./circle-plus.svg": "920c",
	"./circle-x.svg": "87c0",
	"./close-white.svg": "f2da",
	"./close.svg": "5b98",
	"./code-empty.svg": "c275",
	"./code-icons/collapse.svg": "2230",
	"./code-icons/css.svg": "24d4",
	"./code-icons/expand.svg": "15b8",
	"./code-icons/figma.svg": "72d6",
	"./code-icons/html.svg": "66fd",
	"./code-icons/react.svg": "2edf",
	"./code-icons/sass.svg": "e175",
	"./code-icons/storybook.svg": "4a48",
	"./code-icons/tailwind.svg": "5b7e",
	"./code-icons/typescript.svg": "0631",
	"./code-icons/vscode.svg": "8c66",
	"./code-icons/vue.svg": "2949",
	"./code-icons/xd.svg": "f691",
	"./code.svg": "04c7",
	"./codepen.svg": "8800",
	"./cog.svg": "0572",
	"./comments.svg": "b620",
	"./community-survey.svg": "9328",
	"./compare-0.svg": "0efe",
	"./compare-1.svg": "b43f",
	"./compare.svg": "578b",
	"./copy-alt.svg": "c8c5",
	"./copy.svg": "8619",
	"./current-screen.svg": "dbe6",
	"./custom-plan-bottle.svg": "e88d",
	"./custom-plan-puzzle.svg": "7d84",
	"./desktop-computer.svg": "db87",
	"./desktop.svg": "7f58",
	"./divide.svg": "3331",
	"./download-dark.svg": "3644",
	"./download-sandbox.svg": "db28",
	"./download-zip.svg": "2069",
	"./download.svg": "1574",
	"./draghandler.svg": "d990",
	"./emoji/ace.svg": "76f8",
	"./emoji/bulb.svg": "36e1",
	"./emoji/ghost.svg": "1609",
	"./emoji/joystick.svg": "453a",
	"./emoji/magician.svg": "20f7",
	"./emoji/octopus.svg": "6a71",
	"./emoji/paint.svg": "509f9",
	"./emoji/spaceship.svg": "ea2d",
	"./emoji/submarine.svg": "b99e",
	"./emoji/watch.svg": "fda7",
	"./emoji/wfh.svg": "eead",
	"./empty-team-icon.svg": "79b3",
	"./external-link.svg": "fc9b",
	"./eye.svg": "6b9d",
	"./figma-multi.svg": "8ad6",
	"./figma.svg": "323e",
	"./full-project.svg": "e9f0",
	"./gear.svg": "a779",
	"./github.svg": "5058",
	"./google-logo-white.svg": "046e",
	"./google-logo.svg": "7a0e",
	"./grid.svg": "305d",
	"./hand.svg": "8017",
	"./horizontal-list.svg": "a0a3",
	"./html-logo.svg": "a116",
	"./image-mask.svg": "e715",
	"./image-png.svg": "b8ba",
	"./image-svg.svg": "fd6d",
	"./info.svg": "a407",
	"./inspect.svg": "87cf",
	"./interactive.svg": "7c499",
	"./left-notch.svg": "3a4c",
	"./link.svg": "a33e",
	"./loader-line.svg": "6d3f",
	"./lock.svg": "9e15",
	"./mask.svg": "1657",
	"./minus.svg": "6557",
	"./mobile-burger.svg": "0689",
	"./mobile.svg": "4f2c",
	"./multiple-selection.svg": "168d",
	"./new-ribbon.svg": "0dc9",
	"./notifications-alert.svg": "6a4f",
	"./notifications.svg": "3c063",
	"./open-window.svg": "e522",
	"./page-enlarge.svg": "04b5",
	"./page-minimize.svg": "7449",
	"./paint.svg": "d4fc",
	"./pencil.svg": "72ab",
	"./play-education.svg": "d86d",
	"./play.svg": "bd29",
	"./plugin-figma.svg": "eb4e",
	"./plugin-sketch.svg": "4c19",
	"./plugin-xd.svg": "d33a",
	"./plus.svg": "1d3e",
	"./popular-ribbon.svg": "5813",
	"./powered-by-stripe.svg": "ff1e",
	"./project-figma-design.svg": "6bba",
	"./project-xd-design.svg": "dd41",
	"./publish.svg": "ea0e",
	"./quirky-arrow.svg": "81d3",
	"./reached-screens.svg": "2168",
	"./react-logo.svg": "d799",
	"./refresh-icon.svg": "a181",
	"./reply.svg": "bae4",
	"./responsive.svg": "f140",
	"./restore.svg": "1baf",
	"./rocket-full.svg": "9fd2",
	"./rocket-pro.svg": "ed94",
	"./rocket.svg": "c9ab",
	"./save-money-ribbon.svg": "9dfb",
	"./search.svg": "74b7",
	"./select-arrow-down-white.svg": "8d81",
	"./select-arrow-down.svg": "eeae",
	"./selection.svg": "8cda",
	"./send.svg": "f8dc",
	"./settings-icon.svg": "44e9",
	"./settings.svg": "d767",
	"./share-2.svg": "2d3e",
	"./share-download.svg": "d073",
	"./share.svg": "26db",
	"./sketch-multi.svg": "a14c",
	"./sketch.svg": "2eb4",
	"./slack-logo.svg": "701a",
	"./small-arrow-down.svg": "db7a",
	"./small-arrow-right.svg": "3303",
	"./spin.svg": "4282",
	"./stack.svg": "5548",
	"./storybook-beta.svg": "baa5",
	"./storybook-disabled.svg": "693a",
	"./storybook.svg": "42e1",
	"./tablet.svg": "baa2",
	"./talking-bubble-alert.svg": "10fb",
	"./talking-bubble-full.svg": "3bbc",
	"./talking-bubble.svg": "7db6",
	"./three-dots-horizontal.svg": "5351",
	"./three-dots-vertical.svg": "570f",
	"./tooltip-code-example.svg": "1ab7",
	"./tooltip-new-banner.svg": "26b5",
	"./trash.svg": "1264",
	"./uncheck.svg": "bbe4",
	"./v-sign.svg": "5cba",
	"./vue-logo.svg": "93a1",
	"./warn.svg": "d0e16",
	"./web-component-bg.svg": "1192",
	"./white-lock.svg": "8626",
	"./wrench.svg": "2536",
	"./zip.svg": "6633"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcb7";